import { createAction } from '@reduxjs/toolkit';
import { ActiveTask, ErrorObject } from 'types';

export const fetchActiveTasks = createAction('TASKS/FETCH');
export const fetchActiveTasksRequest = createAction('TASKS/FETCH_REQUEST');
export const fetchActiveTasksSuccess = createAction<ActiveTask[]>('TASKS/FETCH_SUCCESS');
export const fetchActiveTasksFailure = createAction<ErrorObject>('TASKS/FETCH_FAILURE');
export const fetchActiveTasksFulfill = createAction('TASKS/FETCH_FULFILL');
